module.exports = __webpack_public_path__ + "img/answer_layout_3.54e74d2f.svg";